<div class="lum-modal client-profile-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Advance Invoice Settings</span
    >
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <form [formGroup]="form" class="invoice-note-form__wrapper" (submit)="onSubmit()">
    <div class="lum-modal__body">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Frequency</div>
            <mat-select class="lum-select" formControlName="frequency">
              <mat-option
                *ngFor="let item of frequencyList; trackBy: trackByLabel"
                [value]="item.value"
              >
                {{ item.label }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Payment Terms</div>
            <mat-select class="lum-select" formControlName="payment_term_title">
              <mat-option
                *ngFor="let term of paymentTerms$ | async; trackBy: trackByLabel"
                [value]="term?.label"
              >
                {{ term?.label }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Delivery Type</div>
            <mat-select class="lum-select" formControlName="delivery_type">
              <mat-option
                *ngFor="let item of deliveryTypeList; trackBy: trackByLabel"
                [value]="item.value"
              >
                {{ item.label }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <lum-filter-client-purchase-order-type
              label="Invoice Type"
              [displayValue]="
                this.form.get('client_purchase_order_type_label')?.value
              "
              (selectInvoiceEvent)="onSetInvoiceType($event)"
            ></lum-filter-client-purchase-order-type>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="'red_DV-2964_automated_billing' | featureFlag">
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Due Date</div>
            <input type="date" class="form-control" formControlName="due_date" />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Autopay</div>
            <mat-slide-toggle formControlName="autopay">Autopay</mat-slide-toggle>
          </div>
        </div>
      </div>

      <div class="row">
        <ng-container *ngIf="form.get('autopay').value">
          <div class="col-6" *ngIf="'red_DV-2964_automated_billing' | featureFlag">
            <div class="form-group">
              <div class="lum-label">Autopay After Days</div>
              <input
                type="number"
                class="form-control"
                formControlName="autopay_after_days"
                min="0"
              />
              <div
                *ngIf="
                  form.controls['autopay_after_days'].invalid &&
                  (form.controls['autopay_after_days'].dirty ||
                    form.controls['autopay_after_days'].touched)
                "
              >
                <small
                  class="text-danger"
                  *ngIf="
                    form.controls['autopay_after_days'].invalid &&
                    form.controls['autopay_after_days'].touched
                  "
                >
                  Please enter a valid non-negative integer
                </small>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Alternate Ids</div>
            <mat-form-field class="example-chip-list w-100" appearance="outline">
              <mat-chip-list #chipList aria-label="Alternate id selection">
                <mat-chip
                  *ngFor="let alternateId of alternateIdsFormArray?.value"
                  class="lum-chip"
                  (removed)="onRemoveAlternateId(alternateId)"
                >
                  {{ alternateId }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  #alternateIdInput
                  placeholder="Press enter to add alternate id..."
                  [formControl]="alternateIdsCtrl"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="onAddAlternateId($event)"
                />
              </mat-chip-list>
            </mat-form-field>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <lum-filter-tag
              ngDefaultControl
              formControlName="tags"
              [value]="tagIds"
              label="Tags"
              (onFilterSelect)="onSetTags($event)"
            ></lum-filter-tag>
          </div>
        </div>

        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Internal Sales Channel</div>
            <lum-channel-control
              formControlName="defaultPosChannel"
              [isPosChannel]="true"
              matTooltip="Not editable. Invoice created from B2B Portal."
              [disabled]="data.createdFrom === eInvoiceCreatedFrom.B2BPORTAL"
              [matTooltipDisabled]="
                data.createdFrom !== eInvoiceCreatedFrom.B2BPORTAL
              "
            ></lum-channel-control>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="lum-label">Auto Push Updates To Sales Order</div>
            <mat-slide-toggle
              formControlName="autoPushUpdatesToSalesOrder"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>

      <ng-container *ngIf="customFieldsEnabled">
        <hr />
        <div class="form-group">
          <div class="lum-label">Custom Fields</div>
          <lum-custom-field-form-group
            [customFieldObject]="eCustomFieldObject.CLIENT_INVOICE"
            [formCustomFieldValues]="customFieldValues"
            (onChange)="onCustomFieldChange($event)"
          ></lum-custom-field-form-group>
        </div>
      </ng-container>
    </div>
    <div class="lum-modal__footer">
      <div class="flex ml-auto lum-modal__action">
        <button
          type="button"
          class="lum-button lum-button--secondary mr-2"
          mat-button
          (click)="onClose()"
        >
          Discard
          <lum-ui-icon
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
        </button>
        <button
          [disabled]="form.invalid"
          mat-button
          type="submit"
          class="lum-button"
        >
          Save
          <lum-ui-icon
            class="ml-2-5"
            icon="content-save"
            color="#ffffff"
            width="23"
            height="23"
          ></lum-ui-icon>
        </button>
      </div>
    </div>
  </form>
</div>
